import { api } from "../apiCore";

export function getConfigurationLogs(data) {
	let url;
	switch (data.user_role) {
	case 'system_admin':
		url = `/system_admin/log/zip/${data.device_id}?action=request`;
		break;
	case 'customer_service':
		url = `/customer_service/log/zip/${data.device_id}?action=request`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/log/zip/${data.device_id}?action=request`;
		break;
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'user':
	case 'partner_view':
	case 'storage_manager':
	case 'storage_user':
	case 'custom_user':
		url = `/log/zip/${data.device_id}?action=request`;
		break
	default:
		break
	}

	return api.get(url)
}

export function configurationRequestLog(data) {
	let url;
	switch (data.user_role) {
	case 'system_admin':
		url = `/system_admin/log/zip/${data.device_id}?start_date=${data.start_date}&end_date=${data.end_date}&action=${data.action}&type=${data.type}`;
		break;
	case 'customer_service':
		url = `/customer_service/log/zip/${data.device_id}?start_date=${data.start_date}&end_date=${data.end_date}&action=${data.action}&type=${data.type}`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `/partners/log/zip/${data.device_id}?start_date=${data.start_date}&end_date=${data.end_date}&action=${data.action}&type=${data.type}`;
		break;
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'user':
	case 'partner_view':
	case 'storage_manager':
	case 'storage_user':
	case 'custom_user':
		url = `/log/zip/${data.device_id}?start_date=${data.start_date}&end_date=${data.end_date}&action=${data.action}&type=${data.type}`;
		break
	default:
		break
	}

	return api.get(url)
}

export function getLiveStatusLogs(device_id, start_ts, end_ts) {
	const url = `/devices/${device_id}/status/log?start_ts=${start_ts}&end_ts=${end_ts}`;

	return api.get(url)
}

export function getDevicesFeatureUsage(data, user_role, company_name=null, partner_name=null) {
	let url;
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/partner/${partner_name}/companies/${company_name}/statistics/feature_usage?start_date=${data.start_date}&end_date=${data.end_date}`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${partner_name}/companies/${company_name}/statistics/feature_usage?start_date=${data.start_date}&end_date=${data.end_date}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${company_name}/statistics/feature_usage?start_date=${data.start_date}&end_date=${data.end_date}`;
			break;
		case 'partner_view':
			url = `/partner_view/companies/${company_name}/statistics/feature_usage?start_date=${data.start_date}&end_date=${data.end_date}`;
			break;
		case 'sales_demo':
			url = `/sales_demo/partner/${partner_name}/companies/${company_name}/statistics/feature_usage?start_date=${data.start_date}&end_date=${data.end_date}`;
			break;
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'user':
		case 'storage_manager':
		case 'storage_user':
		case 'custom_user':
			url = `/statistics/feature_usage?start_date=${data.start_date}&end_date=${data.end_date}`;
			break
	}

	return api.get(url)
}

export function getFleetAdminEventsLog(data) {
	let page_number = 0
	if (data.page_number) {
		page_number = data.page_number
	}

	let url;
	switch(data.user_role) {
		case 'system_admin':
			url = `/system_admin/devices/${data.device_id}/events/log?start_date=${data.start_date}&end_date=${data.end_date}&page_number=${page_number}`
			break
		case 'customer_service':
			url = `/customer_service/devices/${data.device_id}/events/log?start_date=${data.start_date}&end_date=${data.end_date}&page_number=${page_number}`
			break
		case 'partner':
		case 'custom_partner':
			url = `/partners/devices/${data.device_id}/events/log?start_date=${data.start_date}&end_date=${data.end_date}&page_number=${page_number}`
			break
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'user':
		case 'partner_view':
		case 'sales_demo':
		case 'storage_manager':
		case 'storage_user':
		case 'custom_user':
			url = `/devices/${data.device_id}/events/log?start_date=${data.start_date}&end_date=${data.end_date}&page_number=${page_number}`
			break
	}
	if (data.filter_type) {
		url =  url + `&filter_type=${data.filter_type}`
	}

	return api.get(url)
}

export function getAvailableFirmwareList(userRole) {
	let url;
	switch (userRole) {
	case 'system_admin':
		url = `/system_admin/available_firmware`
		break
	case 'customer_service':
		url = `/customer_service/available_firmware`
		break
	case 'partner':
	case 'custom_partner':
		url = `/partners/available_firmware`
		break;
	case 'sales_demo':
		url = `/sales_demo/available_firmware`
		break
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'user':
	case 'partner_view':
	case 'storage_manager':
	case 'storage_user':
	case 'custom_user':
		url = `/available_firmware`
		break
	default:
		break
	}

	return api.get(url)
}

export function applyFirmwareAction(userRole, data) {
	let url;
	switch (userRole) {
	case 'system_admin':
		url = `/system_admin/devices/firmware?ids=${data.device_id}`;
		break
	case 'customer_service':
		url = `/customer_service/devices/firmware?ids=${data.device_id}`;
		break
	case 'partner':
	case 'custom_partner':
		url = `/partners/devices/firmware?ids=${data.device_id}`;
		break
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'storage_manager':
		url = `/devices/firmware?ids=${data.device_id}`;
		break
	default:
		break
	}

	const form = new FormData();
	form.append('version', data.version);
	form.append('restart', data.restart);

	return api.postForm(url, form);
}

export function firmwareCancel(user_role, data) {
	let url;
	switch(user_role) {
		case 'system_admin':
			url = `/system_admin/devices/firmware?ids=${data}`;
			break
		case 'customer_service':
			url = `/customer_service/devices/firmware?ids=${data}`;
			break
		case 'partner':
		case 'custom_partner':
			url = `/partners/devices/firmware?ids=${data}`;
			break
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'storage_manager':
			url = `/devices/firmware?ids=${data}`;
			break
	}

	return api.delete(url);
}

export function getFleetAdminEventsSummary(user_role, company_name=null, partner_name=null ){
	let url;
	switch(user_role) {
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'user':
		case 'storage_manager':
		case 'storage_user':
		case 'custom_user':
			url = `/devices/events/summary`;
			break;
		case 'customer_service':
			url = `/customer_service/partner/${partner_name}/companies/${company_name}/devices/events/summary`;
			break;
		case 'system_admin':
			url = `/system_admin/partner/${partner_name}/companies/${company_name}/devices/events/summary`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `/partners/companies/${company_name}/devices/events/summary`;
			break;
		case 'partner_view':
			url = `/partners/companies/${company_name}/devices/events/summary`;
			break;
		case 'sales_demo':
			url = `/sales_demo/partner/${partner_name}/companies/${company_name}/devices/events/summary`;
			break;
	}

	return api.get(url)
}

export function getIFTAReport(params){
	const queryParams = new URLSearchParams(params).toString();
	const baseUrl = `/reports/ifta`;

	return api.get(`${baseUrl}?${queryParams}`)
}

export function getIFTAReportCsv(params){
	const queryParams = new URLSearchParams(params).toString();
	const baseUrl = `/reports/ifta/csv`;

	return api.get(`${baseUrl}?${queryParams}`, { responseType: 'blob' });
}

export function createIFTAReport(userRole, data) {
	const baseUrl = `/reports/ifta`;

	const form = new FormData();
	form.append('company_id', data.company_id);
	form.append('start_date', data.start_date);
	form.append('end_date', data.end_date);
	form.append('type', data.type);
	if (data.device_ids) {
		form.append('device_ids', data.device_ids);
	}
	form.append('tzname', data.tzname);

	return api.postForm(baseUrl, form);
}

export function getConfigFile(user_role, device_id, checkNewConfig = false) {
	let url;
	switch (user_role) {
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'storage_manager':
		case 'custom_user':
			url = `/config/${device_id}/file`;
			break
		case 'system_admin':
			url = `/system_admin/config/${device_id}/file`;
			break
		case 'customer_service':
			url = `/customer_service/config/${device_id}/file`;
			break
		case 'partner':
		case 'custom_partner':
			url = `/partners/config/${device_id}/file`;
		break
	}

	if (checkNewConfig) {
		url += `?checknewconfig=${checkNewConfig}`
	}

	return api.get(url)
}

export function pushConfigFile (args) {
	const { userRole, deviceId, file, restart, profileId, profileName } = args

	let url;
	switch (userRole) {
	case 'system_admin':
		url = `/system_admin/config/${deviceId}/file`;
		break
	case 'customer_service':
		url = `/customer_service/config/${deviceId}/file`;
		break
	case 'partner':
	case 'custom_partner':
		url = `/partners/config/${deviceId}/file`;
		break
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'storage_manager':
	case 'custom_user':
		url = `/config/${deviceId}/file`;
		break
	default:
		break;
	}

	const form = new FormData();
	form.append('file', file);
	form.append('restart', restart);
	if (profileId != null) {
		form.append('profile_id', profileId);
	}
	if (profileName != null) {
		form.append('profile_name', profileName);
	}

	return api.postForm(url, form);
}

export function pushConfigFileDM100 (args) {
	const { file, restart, device_id } = args

	const url = '/devices/{device_id}/config/binfile';

	const form = new FormData();
	form.append('file', file);
	form.append('restart', restart);
	form.append('device_id', device_id);

	return api.putForm(url, form);
}

export function pushFirmwareFile(user_role, data) {
	let url;
	switch(user_role) { // ToDo: Do we need this switch?
		case 'system_admin':
			url = `/system_admin/firmware/file`;
			break
	}

	const form = new FormData();
	form.append('file', data.file);
	form.append('release_note', data.release_note);

	return api.postForm(url, form);
}

export function deleteFirmware(data) {
	let url = `/system_admin/firmware/file/${data.version}`;

	return api.delete(url);
}

export function cancelFirmware(data) {
	let url = `/device/firmware/totalupdate/cancel?firmware=${data.version}`;

	return api.postForm(url);
}

export function stopFirmware(data) {
	let url = `/device/firmware/totalupdate/stop?firmware=${data.version}`;

	return api.postForm(url);
}

export function resumeFirmware(data) {
	let url = `/device/firmware/totalupdate/resume?firmware=${data.version}`;

	return api.postForm(url);
}

export function startFirmware(data) {
	let url = `/device/firmware/totalupdate/start?firmware=${data.version}`;

	return api.postForm(url);
}

export function pushModemFile(data) {
	const url = `/modem/file`,
		  form = new FormData()
	form.append('file', data.file)
	form.append('model', data.model)
	form.append('version', data.version)
	form.append('release_note', data.release_note)

	return api.postForm(url, form);
}

export function sendNotification() {
	let url = `/email/new-firmware`;

	return api.postForm(url);
}

export function formatSD(userRole, deviceId) {
	let url;
	switch (userRole) {
		case 'system_admin':
			url = `/system_admin/devices/formatcard`
			break
		case 'customer_service':
			url = `/customer_service/devices/formatcard`
			break
		case 'partner':
		case 'custom_partner':
			url = `/partners/devices/formatcard`
			break
		case 'fleet_maintainer':
		case 'fleet_manager':
		case 'group_manager':
		case 'storage_manager':
		case 'custom_user':
			url = `/devices/formatcard`
			break
		default:
			break;
	}

	const form = new FormData()
	form.append('device_id', deviceId)

	return api.postForm(url, form);
}

export function changeFirmwareViewingOptions(firmware_name, is_public){
	let url = `/system_admin/firmware/file/${firmware_name}`;
	const form = new FormData();
	form.append('is_public', is_public);

	return api.postForm(url, form);
}

export function getAvailableModemList() {
	const url = `/available_modems`;

	return api.get(url)
}

export function deleteModem(data) {
	const url = `/modem/file/${data.modem_id}`;

	return api.delete(url);
}

export function upgradeGroupModemFirmware(data){
	const url = `/partner/${data.partner_name}/companies/${data.company_name}/modem/firmware/group/${data.group_name}`
	const form = new FormData()
	form.append('ids', data.devices_id)

	return api.postForm(url, form);
}

export function upgradeModemFirmware(data){
	const url = `/modem/firmware?ids=${data}`

	return api.postForm(url);
}

export function upgradeModemFirmwareCancel(data){
	const url = `/modem/firmware?ids=${data}`

	return api.delete(url);
}

export function addRelease(data) {
	const url = `/releases`;

	const form = new FormData();
	for (let key in data) {
		form.append(key, data[key])
	}

	return api.putForm(url, form);
}
